/**
 * "Einfach / Profi" choice of the v2 settings panels. The Bereich panel
 * (spec 2026-09-23 Mischweg §19, plan index decision 12) remembers it per
 * user under `wm.v2panel.level.<userId>`; the v2 element/container panels
 * call without a user and keep the old per-browser key. The first read for
 * a user takes over the old value, which stays for those panels. Limitation:
 * per user per browser. Storage may be blocked (private mode): then the
 * panels start in "Einfach" and the switch still works for the open panel.
 */
const LEVEL_STORAGE_KEY = 'wm.v2panel.level';

function keyFor(userId) {
  return userId ? `${LEVEL_STORAGE_KEY}.${userId}` : LEVEL_STORAGE_KEY;
}

export function readLevel(userId) {
  try {
    const store = window.localStorage;
    const own = store.getItem(keyFor(userId));
    if (own !== null) return own === 'pro' ? 'pro' : 'simple';
    if (!userId) return 'simple';
    const old = store.getItem(LEVEL_STORAGE_KEY);
    if (old === null) return 'simple';
    store.setItem(keyFor(userId), old);
    return old === 'pro' ? 'pro' : 'simple';
  } catch (e) {
    return 'simple';
  }
}

export function writeLevel(level, userId) {
  try {
    window.localStorage.setItem(keyFor(userId), level);
  } catch (e) {
    // Not remembered; nothing else to do.
  }
}
